define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components", "polished", "../../themes"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents, _polished, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Button = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  var _excluded = ["children"];
  var scales = {
    small: "\n    padding: 4px 16px;\n    font-size: 1.4em;\n  ",
    normal: "\n    padding: 8px 16px;\n    font-size: 1.6em;\n  ",
    big: "\n    padding: 16px 24px;\n    font-size: 1.8em;\n  "
  };

  var kind = function kind(outline, theme) {
    return function (bg, color, iconColor) {
      if (iconColor === void 0) {
        iconColor = 'currentColor';
      }

      var boxShadowColor = outline ? bg : (0, _polished.rgba)(0, 0, 0, 0);
      var backgroundColor = outline ? (0, _polished.rgba)(0, 0, 0, 0) : bg;
      var hoverValues = outline ? "\n      background-color: " + bg + ";\n      color: " + color + ";\n    " : "\n      background-color: " + (0, _polished.mix)(0.3, theme.colors.dark, backgroundColor) + ";\n  ";
      return "\n    background-color: " + backgroundColor + ";\n    box-shadow: inset 0 0 0 1px " + boxShadowColor + ";\n    color: " + (outline ? bg : color) + ";\n    transition: background 0.4s " + theme.easing.ease + ", color 0.2s " + theme.easing.ease + ", box-shadow 0.8s " + theme.easing.ease + ", ;\n\n    &:hover,\n    &:focus {\n      " + hoverValues + "\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);\n    }\n\n    box-icon {\n      fill: " + iconColor + "\n      transition: fill 0.2s " + theme.easing.ease + ";\n    }\n  ";
    };
  };

  var kinds = function kinds(outline, theme) {
    var get = kind(outline, theme);
    return {
      primary: get(theme.colors.secondary, theme.colors.white),
      secondary: get(theme.colors.primary, theme.colors.white),
      cancel: get(theme.colors.red, theme.colors.white),
      aux: "\n      " + get(theme.colors.gray, theme.colors.dark, theme.colors.primary) + ";\n      color: " + theme.colors.dark + ";\n\n      &:hover,\n      &:focus {\n        background-color: " + theme.colors.primary + ";\n        color: " + theme.colors.white + ";\n\n        box-icon {\n          fill: " + theme.colors.white + ";\n        }\n      }\n    ",
      rounded: "\n      " + get(theme.colors.gray, theme.colors.dark, theme.colors.primary, theme.colors.orange) + ";\n      background-color: " + theme.colors.white + ";\n      box-shadow: inset 0 0 0 1px " + theme.colors.lightGray + ";\n      color: " + theme.colors.orange + ";\n\n      &:hover,\n      &:focus {\n        background-color: " + theme.colors.primary + ";\n        color: " + theme.colors.white + ";\n\n        box-icon {\n          fill: " + theme.colors.white + ";\n        }\n      }\n    ",
      loadMore: "\n      " + get(theme.colors.white, theme.colors.orange, theme.colors.primary) + "\n      background-color: " + theme.colors.white + ";\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);\n      color: " + theme.colors.orange + ";\n      width: 100%;\n\n      &:hover,\n      &:focus {\n        background-color: " + theme.colors.primary + ";\n        color: " + theme.colors.white + ";\n\n        box-icon {\n          fill: " + theme.colors.white + ";\n        }\n      }\n    "
    };
  };

  var getScale = function getScale(_ref) {
    var _ref$scale = _ref.scale,
        scale = _ref$scale === void 0 ? 'normal' : _ref$scale;
    return scales[scale];
  };

  var getKind = function getKind(_ref2) {
    var _ref2$kind = _ref2.kind,
        kind = _ref2$kind === void 0 ? 'primary' : _ref2$kind,
        _ref2$outline = _ref2.outline,
        outline = _ref2$outline === void 0 ? false : _ref2$outline,
        theme = _ref2.theme;
    return kinds(outline, theme)[kind];
  };

  var ButtonStyled = (0, _styledComponents.default)('button').withConfig({
    displayName: "Button__ButtonStyled",
    componentId: "sc-vuqi87-0"
  })(["", ";", ";align-items:center;border:0;border-radius:", ";cursor:pointer;display:inline-flex;font-weight:", ";justify-content:center;line-height:24px;text-decoration:none;transition:all 0.2s ", ";box-icon + span{margin-left:8px;}", " &:focus{", "}"], getKind, getScale, function (_ref3) {
    var kind = _ref3.kind;
    return kind === 'rounded' ? '16px' : '2px';
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.semibold;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.easing.easeInOut;
  }, function (_ref6) {
    var disabled = _ref6.disabled;
    return disabled && (0, _styledComponents.css)(["cursor:default;opacity:0.5;"]);
  }, _themes.focusBoxShadow);

  var Button = function Button(_ref7) {
    var children = _ref7.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref7, _excluded);
    return /*#__PURE__*/_react.default.createElement(ButtonStyled, (0, _extends2.default)({}, props, {
      role: "button"
    }), children);
  };

  _exports.Button = Button;
  Button.defaultProps = {
    scale: 'normal',
    kind: 'primary',
    outline: false,
    disabled: false,
    onClick: function onClick() {}
  };
});